import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CollectionApiClient, IPaginationResponse } from '../../../common';
import { IWalletsApiClient } from './i-wallets-api.client';
import {
  IWalletResponse,
  IWalletTransactionResponse,
  IWalletIncomeResponse,
  IPaymentRequestChargeOrderDetailsResponse,
  IWalletTransactionsPaginationParameters,
  IWalletIncomesPaginationParameters,
  ILoadWalletOnlineRequest,
} from '../dtos';
import { FinancialManagementCollections } from '../../common';
import { CustomerManagementCollections } from '../../../customer-management/common';
import { OrderManagementCollections } from '../../../order-management/common';

@Injectable({
  providedIn: 'root'
})
export class WalletsApiClient implements IWalletsApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(FinancialManagementCollections.ModuleName, http);
  }
  getMyWallet(): Observable<IWalletResponse> {
    return this.collectionApiClient.get({
      collectionName: 'CustomerProfiles/my/wallet',
      // collectionName: 'customer-management/customer-profiles/my/wallet',
    });
  }

  getMyWalletTransactions(params?: IWalletTransactionsPaginationParameters): Observable<IPaginationResponse<IWalletTransactionResponse>> {
    return this.collectionApiClient.get({
      collectionName: 'CustomerProfiles/my/wallet-transactions',
      paginationParameters: params,
    });
  }

  getMyWalletIncomes(params?: IWalletIncomesPaginationParameters): Observable<IPaginationResponse<IWalletIncomeResponse>> {
    return this.collectionApiClient.get({
      collectionName: 'CustomerProfiles/my/wallet-incomes',
      paginationParameters: params,
    });
  }

  loadWalletOnline(request: ILoadWalletOnlineRequest): Observable<IPaymentRequestChargeOrderDetailsResponse> {
    return this.collectionApiClient.post({
      collectionName: OrderManagementCollections.walletLoadOnline,
      body: request,
    });
  }
}
